import { RESCHEDULE_REASON_OTHER } from '@onward-delivery/core';

export const isRescheduleReasonValid = ({ reason, notes }) =>
    !!reason && (reason !== RESCHEDULE_REASON_OTHER || !!notes?.trim());

export const buildReschedulePatch = ({ reason, notes }) => ({
    reschedule_reason_code: reason || null,
    reschedule_reason_notes: notes?.trim() || null,
});
